var _defs, _style, _g, _g2, _path, _path2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPepeGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg86",
    width: 503,
    height: 444,
    viewBox: "-1 222 503 205.70285",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1119"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style47"
  }, "\n        .H {\n            fill: none\n        }\n\n        .I {\n            stroke: #000\n        }\n\n        .J {\n            stroke-width: 2\n        }\n\n        .K {\n            stroke-miterlimit: 10\n        }\n    ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g55",
    className: "I J K"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path49",
    fill: "#556b2f",
    d: "m 497,262 c 3,29 -14,37 -28,43 -5,11 -28,27 -38,28 13,4 41,46 36,67 9,3 17,17 1,27 -30,20 17,30 -50,46 C 327,551 225,522 97,502 35,494 9,436 10,365 7,354 44,233 86,233 117,132 189,100 286,150 c 48,-32 129,-29 137,42 14,4 34,15 44,24 -3,11 10,11 18,16 -4,15 6,14 12,30 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 180,297 c 13,16 178,36 155,-9",
    className: "H"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    fill: "#ffffff",
    d: "m 344,258 -7,29 c -15,13 -122,28 -161,-12 36,-43 122,-55 168,-17 z m 152,13 c -20,38 -122,36 -158,17 13,-62 125,-64 158,-17 z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g67"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    dur: 6.8,
    repeatCount: "indefinite",
    values: "#000;#245ea4;#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "m 256,241 c 45,-1 45,60 0,60 -45,0 -45,-61 0,-60 z"
  }), /*#__PURE__*/React.createElement("use", {
    id: "use58",
    className: "H I J K",
    href: "#A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "m 444,268 c 0,39 -63,39 -63,0 0,-39 63,-39 63,0 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g65",
    className: "I J K"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use61",
    className: "H",
    href: "#B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fill: "#ffffff",
    d: "m 237,258 c 7,0 7,11 0,11 -7,0 -8,-11 0,-11 z m 33,1 c 8,-1 8,13 0,13 -9,0 -9,-13 0,-13 z m -24,20 c 3,0 3,5 0,5 -4,0 -4,-5 0,-5 z m 182,-21 c 9,0 9,12 0,13 -9,0 -9,-12 0,-13 z m -29,-5 c 7,-1 7,10 0,10 -7,0 -7,-11 0,-10 z m 0,23 c 4,0 4,6 0,6 -4,0 -4,-6 0,-6 z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    d: "m 242,350 c 18,-3 49,-16 65,-28 m 122,11 c -26,11 -55,14 -77,-1 m 41,30 c 1,-7 -12,-20 -17,-20 M 338,241 c 49,-13 90,-23 147,4",
    className: "H I J K"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "C",
    fill: "#a52a2a",
    d: "m 419,472 c -59,1 -305,-11 -268,-91 37,-25 52,17 93,23 104,31 158,19 225,-4 21,7 3,28 -13,39 19,20 -34,34 -37,33 z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g80",
    className: "I"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g76",
    className: "J K"
  }, /*#__PURE__*/React.createElement("use", {
    id: "use72",
    href: "#C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    d: "m 170,399 c 55,57 250,42 284,39 M 79,273 88,236 m 86,38 c -24,2 -45,-19 -4,-14 26,-9 49,-30 86,-34 34,-1 43,1 76,12 31,-27 82,-23 132,-16 m -130,11 c -6,-29 -83,-20 -79,-20 -29,1 -62,29 -92,33 m -10,-49 c 44,-34 128,-32 160,17 m -29,-63 c 7,6 17,30 14,44 32,-7 85,-10 123,-4",
    className: "H",
    transform: "translate(2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPepeGreen);
export default __webpack_public_path__ + "static/media/pepe-green.8459aaa3b473b29b90c420674f6fb443.svg";
export { ForwardRef as ReactComponent };